/**
 * Product builder media and preview slide helpers.
 * Load after productBuilderPreview and before express-product-builder.js.
 */
(() => {
  window.Express = window.Express || {};

  function mediaToOptionImage(media, fallbackAlt) {
    if (!media) return null;
    if (typeof media === 'string') {
      return media ? { url: media, alt: fallbackAlt } : null;
    }

    const url = media.url || media.previewUrl || media.src || media.thumbnailUrl || '';
    if (!url) return null;

    return {
      url,
      alt: media.alt || media.altText || fallbackAlt,
    };
  }

  function getProductThumbnailUrl(product) {
    return product?.product_image?.thumbnailUrl
      || product?.product_image?.url
      || product?.images?.[0]?.thumbnailUrl
      || product?.images?.[0]?.url
      || '';
  }

  function getThumbnail(option) {
    return mediaToOptionImage(option?.thumbnail, option?.label || 'Option');
  }

  function getOptionVisualImage(option) {
    return [
      option?.thumbnail,
      option?.previewMedia?.[0],
      option?.images?.[0],
      option?.image,
    ].map((media) => mediaToOptionImage(media, option?.label || 'Option')).find(Boolean) || null;
  }

  function getProductPreviewImage(config) {
    const product = config?.product || {};
    const media = product.product_image || product.images?.[0] || null;
    if (!media) return null;

    if (typeof media === 'string') {
      return media ? { url: media, alt: product.title || 'Preview' } : null;
    }

    const url = media.url || media.previewUrl || media.src || media.thumbnailUrl || '';
    if (!url) return null;

    return {
      url,
      alt: media.alt || media.altText || product.title || 'Preview',
    };
  }

  function getGalleryPreviewSlides(config, group, previewHelper) {
    const slides = [];
    const productFallback = getProductPreviewImage(config);
    const groupHasPreview = (group.options || []).some((option) =>
      previewHelper.getOptionPreviewImages({
        ...option,
        groupKey: group.groupTypeKey,
        groupLabel: group.label,
      }).length > 0
    );

    if (groupHasPreview && productFallback) {
      slides.push({
        key: '__fallback',
        type: 'fallback',
        url: productFallback.url,
        alt: productFallback.alt,
        title: config?.product?.title || group.label || 'Preview',
      });
    }

    (group.options || []).forEach((option) => {
      const optionImages = previewHelper.getOptionPreviewImages({
        ...option,
        groupKey: group.groupTypeKey,
        groupLabel: group.label,
      });
      const image = optionImages[0] || null;

      if (!image) return;

      slides.push({
        key: option.key,
        type: 'option',
        url: image.url,
        alt: image.alt || option.label || 'Preview',
        optionKey: option.key,
        optionLabel: option.label || '',
        groupLabel: group.label || '',
      });
    });

    return slides;
  }

  window.Express.productBuilderMedia = {
    getGalleryPreviewSlides,
    getOptionVisualImage,
    getProductPreviewImage,
    getProductThumbnailUrl,
    getThumbnail,
    mediaToOptionImage,
  };
})();
